import React from 'react';

const ILMUMalaysia = () => (
  <article className="news-article-body">
    <p className="news-lead">
      In March 2025, Malaysia announced ILMU - which stands for Intelligent Language Model
      Unified, and conveniently also means "knowledge" in Malay. It's Malaysia's first
      nationally developed large language model, backed by the government and built by a
      consortium of local universities and technology companies. The goal is straightforward:
      build an AI system that actually understands Malaysian languages, culture, and context,
      rather than relying entirely on foreign models that treat Bahasa Malaysia as an
      afterthought.
    </p>

    <h2>Why Malaysia needed its own model</h2>
    <p>
      Most frontier AI models - GPT-4, Claude, Gemini - were primarily trained on English
      data. They handle Bahasa Malaysia passably but miss nuances, local terminology,
      cultural references, and the unique code-switching between Malay, English, and
      Chinese that characterises everyday Malaysian communication.
    </p>
    <p>
      For government services, education, and local businesses, this matters. A model that
      can't understand "tolong semak this dokumen" or distinguish between formal Bahasa
      Malaysia and casual everyday speech is limited in what it can do for most Malaysians.
    </p>

    <h2>What ILMU is built on</h2>
    <p>
      ILMU is built on a foundation model architecture incorporating:
    </p>
    <ul>
      <li><strong>Multilingual training data:</strong> Bahasa Malaysia, English, Mandarin Chinese, and Tamil, with significant Malaysian web corpus inclusion</li>
      <li><strong>Local knowledge:</strong> Malaysian law, education materials, government documents, and local news sources</li>
      <li><strong>Cultural alignment:</strong> Fine-tuning specifically for Malaysian communication styles and values</li>
    </ul>
    <p>
      The initial model is targeted at government applications, education, and SME business
      tools. Larger deployments are planned under Malaysia's National AI Implementation
      Initiative (NAII).
    </p>

    <h2>Who's building it</h2>
    <p>
      ILMU is a consortium effort. Universiti Malaya, Universiti Teknologi Malaysia, and
      MIMOS Berhad (Malaysia's national applied ICT research centre) are the main technical
      contributors. The project is funded through the Digital Economy Corporation (MDEC)
      and falls under Malaysia's National AI Roadmap.
    </p>
    <p>
      Collaboration with Alibaba Cloud and Hugging Face for infrastructure and tooling was
      also reported, which gives the project access to proven training and deployment
      pipelines without starting from scratch.
    </p>

    <h2>Part of a bigger picture</h2>
    <p>
      ILMU sits within Malaysia's broader AI strategy, which includes the National AI
      Office (NAIO) established in 2024 and the AI Governance and Ethics (AIGE) framework.
      Malaysia has been one of Southeast Asia's more active countries in building both the
      technical and governance foundations for AI, recognising that depending entirely on
      foreign models creates both capability and sovereignty risks.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Building a national AI model isn't about competing with OpenAI. It's about ensuring
        that AI systems serving Malaysian citizens actually understand Malaysian context.
        ILMU is an investment in digital sovereignty - and a signal that the era of every
        country depending entirely on a handful of US or Chinese AI providers is starting
        to change.
      </p>
    </div>
  </article>
);

export default ILMUMalaysia;
